import { makeAutoObservable } from 'mobx'
import type { IResponsePowerDialerStatistics } from 'entities/PowerDialer/api/types'

export class PowerDialerStatistics {
  enrolled: number | null = null
  answered: number | null = null
  noAnswered: number | null = null
  contacted: number | null = null
  noContacted: number | null = null
  skipped: number | null = null

  constructor(statistics?: IResponsePowerDialerStatistics) {
    if (!statistics) {
      this.enrolled = null
      this.answered = null
      this.noAnswered = null
      this.contacted = null
      this.noContacted = null
      this.skipped = null
      return
    }

    this.enrolled = statistics.enrolled
    this.answered = statistics.answered
    this.noAnswered = statistics.no_answered
    this.contacted = statistics.contacted
    this.noContacted = statistics.no_contacted
    this.skipped = statistics.skipped

    makeAutoObservable(this)
  }

  private get _base(): number {
    return this.enrolled ?? 0
  }

  get enrolledPercent(): number {
    return this._base > 0 ? Math.round((this._base / this._base) * 100) : 0
  }

  get contactedPercent(): number {
    return this._base > 0 && this.contacted !== null
      ? Math.round((this.contacted / this._base) * 100)
      : 0
  }

  get notContactedPercent(): number {
    return this._base > 0 && this.noContacted !== null
      ? Math.round((this.noContacted / this._base) * 100)
      : 0
  }

  get answeredPercent(): number {
    return this._base > 0 && this.answered !== null
      ? Math.round((this.answered / this._base) * 100)
      : 0
  }

  get noAnsweredPercent(): number {
    return this._base > 0 && this.noAnswered !== null
      ? Math.round((this.noAnswered / this._base) * 100)
      : 0
  }

  get skippedPercent(): number {
    return this._base > 0 && this.skipped !== null
      ? Math.round((this.skipped / this._base) * 100)
      : 0
  }
}
